import React from "react";
import styled from "styled-components";
import { VideoCard } from "./VideoCard";
import { AnalysisVideo } from "@/api/campaign";
import { mediaPhone } from "@/shared/theme/breakpoints";

const Container = styled.div`
	width: 100%;
	padding-bottom: 32px;
`;

const Header = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin-top: 16px;
	margin-bottom: 16px;
`;

const Title = styled.h3`
	font-size: 20px;
	font-weight: 700;
	color: #222222cc;
	margin: 0;
`;

const TitleLine = styled.div`
	flex: 1;
	height: 1px;
	background: #22222266;
`;

const GridContainer = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
	gap: 16px;

	${mediaPhone`
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 16px 12px;
	`}
`;

interface VideoCardListProps {
	videos?: AnalysisVideo[];
	title?: string;
	onVideoClick?: (videoId: string) => void;
}

export const VideoCardList: React.FC<VideoCardListProps> = ({ videos, title = "Campaign Videos", onVideoClick }) => {
	// Use videos from props, or empty array if none provided
	const displayVideos = videos || [];

	return (
		<Container>
			<Header>
				<Title>{title}</Title>
				<TitleLine />
			</Header>

			{displayVideos.length > 0 ? (
				<GridContainer>
					{displayVideos.map((video) => (
						<VideoCard key={video.id} video={video} onClick={onVideoClick} />
					))}
				</GridContainer>
			) : (
				<div style={{ padding: "2rem", textAlign: "center", color: "#999" }}>No videos available</div>
			)}
		</Container>
	);
};
